import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SectionHeader } from "../../../Common/SharedComponents";
import { PPToProductLables } from "../../Resource/Contents";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { ProductAllocation } from "../../../../../../../Wrap/Models/Domains/Transfer/Gia/ProductAllocation";
import { PPToProductAction } from "../../Actions/PPToProductActions";
import { InvestmentReviewTable, InvestmentReviewType } from "../InvestmentDetails/InvestmentReviewTable";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { IsaAllowanceOverview } from "../../../PortfolioDashboard/Components/ProductOverview/Component/IsaAllowanceOverview";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../../Common/Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { DocumentCategory } from "../../../../../../../Wrap/Constants/Enums/Domain/DocumentCategory";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { subAccountTypeMap } from "../../../PortfolioDashboard/Components/Performance/Resource/Contents";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    hasCashIsa?: boolean;
    clientAccount: ClientAccount;
}

interface IReviewState {
    buyAllocations: InvestmentAllocation[];
    sellAllocations: InvestmentAllocation[];

}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {
            buyAllocations: [],
            sellAllocations: []
        };
    }

    private getSectionHeader(subAccountType: SubAccountType) {
        let str = PPToProductLables.investmentsToBuyIn;
        switch (subAccountType) {
            case SubAccountType.StocksIsa:
                return str + "ISA"
            case SubAccountType.Npr:
                return str + "abrdn SIPP"
            default:
                return PPToProductLables.investmentsToBuy;
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const { data } = this.props;
        PPToProductAction.getAllocationAssetDetails(data.Contribution?.BedAndProductWrapperInstruction?.BuyAllocations, data.Contribution?.BedAndProductWrapperInstruction?.SellAllocations,
            (result,buyAllocations,sellAllocations)=>{
                this.setState({
                    buyAllocations: this.transformToAllocation(result, buyAllocations ?? []),
                    sellAllocations: this.transformToAllocation(result, sellAllocations ?? [])
            });
        });

        InstructionDocumentTypeRequestTriggerActionsCreator.triggerByInstructionId(
            getQueryParameters()["id"] as string,
            [DocumentCategory.Illustration]
        );
    }

    transformToAllocation(instruments: Instrument[], allocations: ProductAllocation[]): InvestmentAllocation[] {
        if (instruments.length == 0) return [];
        let transformAlloations: InvestmentAllocation[] = [];
        allocations.forEach((x) => {
            let alloation: InvestmentAllocation = {
                ProductId: x.ProductId,
                Percentage: x.Percentage,
                Name: instruments.find(y => y.ProductId == x.ProductId)?.Name
            };
            transformAlloations.push(alloation);
        });
        return transformAlloations;
    }

    public render(): JSX.Element {
        const processType = ProcessType.PPToProduct;
        const { data, type, clientAccount } = this.props;
        const contribution = data.Contribution;
        const ppAccount = clientAccount.SubAccounts.find(x => x.HierarchyId == data.Contribution.BedAndProductWrapperInstruction.FromHierarchyId?.HierarchyIdString??"");
        const transferToAccount = clientAccount.SubAccounts.find(x => x.HierarchyId == data.Contribution.BedAndProductWrapperInstruction.ToHierarchyId?.HierarchyIdString??"");
        if (ppAccount == null || transferToAccount == null) {
            return <Alert alertType={AlertType.Warning} message={"No Data"} />;
        }

        let investmentDetailTableConfig = [];

        investmentDetailTableConfig.push({
            title: "Did you give financial advice?",
            data: contribution.AdviceGiven ? "Yes" : "No",
        });
        investmentDetailTableConfig.push({
            title: "Paying From",
            data: ppAccount.ProductDisplayName + " " + ppAccount.ClAccountId,
        });
        investmentDetailTableConfig.push({
            title: "Paying To",
            data: transferToAccount.ProductDisplayName + " " + transferToAccount.ClAccountId,
        });
        investmentDetailTableConfig.push({
            title: "PP to " + transferToAccount.ProductDisplayName + " amount",
            data: (<>
            <span>{ MoneyDisplayHelper.FromatMoneyDisplay(
                contribution.BedAndProductWrapperInstruction.BedProductAmount?.Amount,
                contribution.BedAndProductWrapperInstruction.BedProductAmount?.Currency ?? CurrencyCode.GBP
            )}</span>
            <br />
            {contribution.BedAndProductWrapperInstruction?.IsTaxRelief && (
                <span>
                    {MoneyDisplayHelper.FromatMoneyDisplay(
                    (contribution.BedAndProductWrapperInstruction.BedProductAmount?.Amount || 0) * 1.25,
                    contribution.BedAndProductWrapperInstruction.BedProductAmount?.Currency ?? CurrencyCode.GBP
                    ) + " including tax relief(gross)"}
                </span>
            )}
            </> )
        });

        return (
            <div>
                <h2>Review</h2>
                {transferToAccount.SubAccountType == SubAccountType.StocksIsa && clientAccount != null && (
                    <IsaAllowanceOverview headaccount={clientAccount} />
                )}

                <div className="d-flex flex-space">
                    {SectionHeader("Investment Details")}
                    <button
                        className="edit-circle-icon-button label-sr-only"
                        title="Edit"
                        onClick={() => {
                            if (transferToAccount?.SubAccountType === SubAccountType.JuniorSipp || transferToAccount?.SubAccountType === SubAccountType.Npr) {
                                Navigator.navigateToAndPreserveQueryParameters(
                                    Urls.get().PPToAbrdnSIPPInvestmentDetails
                                );
                            } else {
                                Navigator.navigateToAndPreserveQueryParameters(
                                    Urls.get().PPToProducInvestmentDetails
                                );
                            }
                        }}
                    >
                        <span className="icon" aria-hidden="true"></span>
                        <span className="text">Edit</span>
                    </button>
                </div>
                {investmentDetailTableConfig.length > 0 && <Typography type="common" wrapCss="text-bold" config={investmentDetailTableConfig} />}
                <br />

                {SectionHeader(PPToProductLables.investmentsToSell)}
                <InvestmentReviewTable
                    data={this.state.sellAllocations}
                    allocationType={InvestmentReviewType.Sell}
                    amount={data.Contribution.BedAndProductWrapperInstruction?.BedProductAmount ?? { Amount: 0, Currency: CurrencyCode.GBP }}
                />
                <br />

                {SectionHeader(this.getSectionHeader(transferToAccount.SubAccountType))}
                <InvestmentReviewTable
                    data={this.state.buyAllocations}
                    allocationType={InvestmentReviewType.Buy}
                    amount={{
                        Amount: (data.Contribution.BedAndProductWrapperInstruction?.BedProductAmount?.Amount ?? 0) *
                            (contribution.BedAndProductWrapperInstruction?.IsTaxRelief ? 1.25 : 1), 
                        Currency: CurrencyCode.GBP
                    }}
                />
            </div>
        );
    }
}
